<template>
<div>
  <div v-for="(item, index) in inputValues" :key="index" class="input-row">
    选项{{index + 1}}: <el-button size="mini" type="danger" class="remove-btn" v-if="!disabled && inputValues && inputValues.length > 2" icon="el-icon-close" @click="removeInput(index)">删除</el-button>
    <div :style="{'margin-bottom': '3px'}" v-for="(langLabel, langKey) in languages" :key="langKey">
      <el-input :placeholder="langLabel" @keyup.native="handleChange" :disabled="disabled" v-model="inputValues[index][langKey]"></el-input>
    </div>
  </div>
  <el-button class="bk-btn bk-btn-ept" type="success" v-if="!disabled" icon="el-icon-plus" @click="addInput"> 添加选项</el-button>
</div>
</template>

<script>
import LANGUAGE from 'common/languages';
export default {
  name: 'mutipleInput',
  props: ['value', 'disabled'],
  data() {
    return {
      languages: LANGUAGE,
      inputValues: this.value && this.value.length ? this.value.concat() : [{}]
    };
  },
  watch: {
    value(val, oldVal) {
      if(val !== oldVal) {
        this.inputValues = this.value && this.value.length ? this.value.concat() : [{}]
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.inputValues);
      this.$parent.$emit('el.form.change', this.inputValues);
    },
    addInput() {
      this.inputValues.push({});
    },
    removeInput(index) {
      if(this.inputValues.length === 2) {
        this.inputValues[index] = {}
        return;
      };
      this.inputValues.splice(index, 1);
      this.$emit('input', this.inputValues);
      this.$parent.$emit('el.form.change', this.inputValues);
    }
  }
};
</script>

<style>
.input-row {
  margin-bottom: 10px;
}
.remove-btn {
  float: right;
}
</style>
